import React, { useState, useEffect } from 'react';
import './PackOpening.css';
import CardComponent from '../ui/CardComponent';

const PackOpening = ({ 
  cards = [], 
  packType = 'standard',
  onComplete
}) => {
  const [currentCardIndex, setCurrentCardIndex] = useState(-1);
  const [revealedCards, setRevealedCards] = useState([]);
  const [isOpening, setIsOpening] = useState(true);
  const [isComplete, setIsComplete] = useState(false);
  const [packAnimation, setPackAnimation] = useState(false);
  const [openingPhase, setOpeningPhase] = useState('initial'); // 'initial', 'shaking', 'opening', 'complete'

  // Animation sequence
  useEffect(() => {
    if (cards.length === 0) return;

    // Initial pack animation
    setTimeout(() => {
      setOpeningPhase('shaking');
    }, 1000);
    
    setTimeout(() => {
      setOpeningPhase('opening');
      setPackAnimation(true);
    }, 3000);
    
    setTimeout(() => {
      setIsOpening(false);
      setCurrentCardIndex(0);
    }, 4000);
    
  }, [cards]);

  // Reveal next card
  const revealNextCard = () => {
    if (currentCardIndex >= 0 && currentCardIndex < cards.length) {
      setRevealedCards(prev => [...prev, cards[currentCardIndex]]);
      
      if (currentCardIndex === cards.length - 1) {
        // All cards revealed
        setIsComplete(true);
      } else {
        // Move to next card
        setCurrentCardIndex(currentCardIndex + 1);
      }
    }
  };

  // Handle completion
  const handleFinish = () => {
    if (onComplete) {
      onComplete(cards);
    }
  };

  const getPackImage = () => {
    switch (packType) {
      case 'fire': return '/packs/fire_pack.png';
      case 'water': return '/packs/water_pack.png';
      case 'earth': return '/packs/earth_pack.png';
      case 'air': return '/packs/air_pack.png';
      case 'light': return '/packs/light_pack.png';
      case 'dark': return '/packs/dark_pack.png';
      case 'premium': return '/packs/premium_pack.png';
      case 'rainbow': return '/packs/rainbow_pack.png';
      default: return '/packs/standard_pack.png';
    }
  };

  if (cards.length === 0) {
    return (
      <div className="pack-empty">
        <p>Aucune carte à ouvrir.</p>
        <button onClick={handleFinish} className="return-button">
          <span className="button-text">Retour</span>
          <span className="button-glow"></span>
        </button>
      </div>
    );
  }

  return (
    <div className="pack-opening-container">
      {isOpening ? (
        <div className={`pack-animation ${openingPhase}`}>
          <div className="pack-image">
            <img src={getPackImage()} alt={`${packType} pack`} className={packAnimation ? 'opening' : ''} />
          </div>
          <div className="pack-info">
            <p className="pack-message">
              {openingPhase === 'initial' && 'Ouverture du pack...'}
              {openingPhase === 'shaking' && 'Le pack réagit...'}
              {openingPhase === 'opening' && 'Cartes révélées !'}
            </p>
            <div className="pack-particles">
              {Array.from({ length: 30 }).map((_, i) => (
                <div 
                  key={i} 
                  className="particle"
                  style={{
                    '--delay': `${Math.random() * 2}s`,
                    '--size': `${Math.random() * 10 + 5}px`,
                    '--x': `${Math.random() * 200 - 100}px`,
                    '--y': `${Math.random() * 200 - 100}px`,
                    '--color': `hsl(${Math.random() * 60 + 200}, 100%, 70%)`,
                  }}
                ></div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <>
          {currentCardIndex < cards.length && !isComplete ? (
            <div className="card-reveal">
              <div 
                className="card-placeholder" 
                onClick={revealNextCard}
              >
                <div className="card-front-face">
                  <CardComponent 
                    card={cards[currentCardIndex]} 
                    flippable={true}
                    size="large"
                    animated={true}
                  />
                </div>
              </div>
              <p className="reveal-instruction">
                Cliquez sur la carte pour la révéler ({revealedCards.length + 1}/{cards.length})
              </p>
            </div>
          ) : (
            <div className="pack-result">
              <h2 className="pack-result-title">Votre Pack {packType}</h2>
              <div className="revealed-cards">
                {revealedCards.map((card, index) => (
                  <div 
                    key={`reveal-${index}`} 
                    className="revealed-card"
                    style={{ animationDelay: `${index * 0.2}s` }}
                  >
                    <CardComponent 
                      card={card}
                      size="small"
                      animated={true}
                      highlighted={
                        card.rarity === 'SR' || 
                        card.rarity === 'SSR' || 
                        card.rarity === 'L' || 
                        card.rarity === 'AC'
                      }
                    />
                  </div>
                ))}
              </div>
              <button className="finish-button" onClick={handleFinish}>
                <span className="button-text">Continuer</span>
                <span className="button-glow"></span>
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PackOpening;